module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "client-item-box new-list",
    attrs: {
      "data-trackdata": _vm.tData
    }
  }, [(_vm.title) ? _c('div', {
    staticClass: "new-list-title"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v(" "), (_vm.banner) ? _c('div', {
    staticClass: "new-list-banner",
    style: ({
      'marginBottom': (_vm.bannerGap + "px")
    }),
    on: {
      "click": _vm.moreAction
    }
  }, [_c('beast-image', {
    staticClass: "img",
    attrs: {
      "lazy": true,
      "image": _vm.banner,
      "containerWidth": _vm.boxWidth
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "new-list-box"
  }, [_c('dynamic-list', {
    attrs: {
      "dataOrigin": _vm.data.dataOrigin,
      "ids": _vm.data.ids || [],
      "listCondition": _vm.listCondition,
      "miniEnv": _vm.miniEnv,
      "listPl": _vm.data.paddingData.pl
    },
    on: {
      "product-simple": _vm.productSimpleJump
    }
  })], 1), _vm._v(" "), (_vm.buttonName) ? _c('div', {
    staticClass: "new-list-button",
    on: {
      "click": _vm.moreAction
    }
  }, [_vm._v(_vm._s(_vm.buttonName))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e08840c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./static/renderer-config/components/new-list.vue
// module id = 661
// module chunks = 1 13